const hostname = window.location.hostname;

const Base =
  hostname.includes("matwprojectusa.org") ||
  hostname.includes("yasir-uat.matwproject.org")
    ? process.env.REACT_APP_BASE_URL_USA
    : process.env.REACT_APP_BASE_URL;

export default Base;